exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "html[dir] ._1scz2mzk7WeH_ny5oYrv7R{margin-top:-4px}._1r_-jalLgbkphbKMXew0ix{font-size:11px}html[dir] ._1r_-jalLgbkphbKMXew0ix{margin:0 12px}._3yvFAGUczEqkCkuyekd5ey{font-size:14px;font-weight:400;max-width:600px;max-height:600px;width:400px}.JPrX56_79sSCmwPZYnXil{font-size:14px;font-weight:400;max-height:80%;overflow:auto}._3r2D7vulZ9b9LezOVnciH8{line-height:30px}html[dir] ._2deIjQ2KfNINseQ4WxAI12{margin:5px 0}._3nnfTyhh3irdXYujP-KZCT{resize:none;height:100px;font-size:14px;font-weight:400;font-size:12px}._3nnfTyhh3irdXYujP-KZCT::-webkit-input-placeholder{color:\"[theme:neutralTertiary, default:#a6a6a6]\";font-size:12px}._3nnfTyhh3irdXYujP-KZCT::-moz-placeholder{color:\"[theme:neutralTertiary, default:#a6a6a6]\";font-size:12px}._3nnfTyhh3irdXYujP-KZCT:-ms-input-placeholder{color:\"[theme:neutralTertiary, default:#a6a6a6]\";font-size:12px}._3nnfTyhh3irdXYujP-KZCT:-moz-placeholder{color:\"[theme:neutralTertiary, default:#a6a6a6]\";font-size:12px}html[dir] .ucC0y83TG0MlWKoznMbv_{border:1px solid \"[theme:neutralTertiary, default:#a6a6a6]\";margin:20px 0 0}", ""]);

// exports
exports.locals = {
	"linkContainer": "_1scz2mzk7WeH_ny5oYrv7R",
	"feedbackLauncher": "_1r_-jalLgbkphbKMXew0ix",
	"dialogContainer": "_3yvFAGUczEqkCkuyekd5ey",
	"content": "JPrX56_79sSCmwPZYnXil",
	"titleText": "_3r2D7vulZ9b9LezOVnciH8",
	"feedbackCategoryCheckbox": "_2deIjQ2KfNINseQ4WxAI12",
	"textArea": "_3nnfTyhh3irdXYujP-KZCT",
	"textAreaContainer": "ucC0y83TG0MlWKoznMbv_"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"minimize":{"orderedValues":false}}!./node_modules/postcss-loader/lib?{"plugins":[null,null]}!./node_modules/sass-loader/lib/loader.js!./obj/mail/view/owa-mail-search-view/lib/components/SearchInContextFeedbackDialog.scss
// module id = 4844
// module chunks = 37